<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Title</mat-label>
      <input [(ngModel)]="fcmData.topicTitle" matInput />
      
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Message</mat-label>
      <textarea [(ngModel)]="fcmData.topicMessage" matInput></textarea>
      <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Topic</mat-label>
      <input [(ngModel)]="fcmData.topic" matInput />
      
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Description</mat-label>
      <input [(ngModel)]="fcmData.topicDescription" matInput />
      
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    [disabled]="
      !fcmData.topicTitle ||
      !fcmData.topicMessage ||
      !fcmData.topic ||
      !fcmData.topicDescription
    "
    mat-flat-button
    color="accent"
    (click)="onPost()"
  >
    Post
  </button>
</mat-dialog-actions>
